<div class="web-preview-container">
  <img [src]="imgLink" alt="Link Image" />
  <div class="settings-preview">
    <div class="sidebar-container">
      <div
        class="sidebar"
        [style.background-color]="accentColor | async"
        [style.color]="(accentColor | async)! | textColorForCustomBackground"
      >
        <h5 class="greeting">{{ greeting | async }}</h5>
        <p class="blurb">{{ blurb | async }}</p>
        <div class="logo">
          @if (logo | async) {
          <img [src]="logo | async" alt="Logo Image" />
          }
        </div>
      </div>
    </div>
    <div class="main">
      <div class="rep-container">
        @for (rep of teamMembers | async; track rep) {
        <div class="rep-card">
          <div class="rep-avatar">
            @if (rep.userAvatarUrl) {
            <img [src]="rep.userAvatarUrl" alt="Avatar Image" />
            } @else {
            <mat-icon class="no-pic">account_circle</mat-icon>
            }
            <div class="presence-signal"></div>
          </div>
          <div class="rep-titles">
            <h5>{{ rep.contactName }}</h5>
            <p>{{ rep.title }}</p>
            <div class="contact-buttons">
              <button
                mat-stroked-button
                class="talk"
                [style.color]="(accentColor | async)! | textColorForWhiteBackground"
              >
                <mat-icon>phone</mat-icon>
                <span> {{ "ONSIP_I18N.LETS_TALK" | translate }}</span>
              </button>
              <button
                mat-stroked-button
                class="video"
                [style.color]="(accentColor | async)! | textColorForWhiteBackground"
              >
                <mat-icon>videocam</mat-icon>
              </button>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
